import { motion } from "framer-motion"
import styled from "styled-components"

import { DEVICE } from "~/constants/device-widths"
import { fontWeight } from "~/utils/styles"

const FormWrapper = styled(motion.div)`
  width: 100vw;
  @media ${DEVICE.laptop} {
    width: 55vw;
  }
  max-width: 100%;
  height: fit-content;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--color-fg);
  form {
    position: relative;
  }
  > * {
    width: 100%;
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > svg {
      width: 15px;
      cursor: pointer;
    }
  }
  section {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    margin-top: 30px;
    gap: 20px;
    padding: 0 40px 30px;
  }
  h1 {
    color: var(--blue);
    font-size: 18px;
    ${fontWeight(595)};
    letter-spacing: 0.75px;
    line-height: 27px;
  }
  h2 {
    font-size: 14px;
    line-height: 17px;
    ${fontWeight(400)};
  }
`

export default FormWrapper
